import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftRequestLikelyToFillExperimentExposedPayload {
  flagKey: string;
  variant: string;
}

/**
 * GOTU-13065 exposure event, both arms; carries the PostHog attribution for the variant.
 * Event: dental_portal:shift_request:likely_to_fill_experiment_exposed
 */
export function fireShiftRequestLikelyToFillExperimentExposed(
  payload: IShiftRequestLikelyToFillExperimentExposedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:shift_request:likely_to_fill_experiment_exposed',
    {
      $feature_flag: payload.flagKey,
      $feature_flag_response: payload.variant,
    },
  );
}
